export default __webpack_public_path__ + "static/media/slides.ae073b3f.png";